import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';
import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout'
import { SearchTextField } from '../../components/SearchTextField';

import { TipoDomicilioProps } from '../../interfaces/catalogos/TipoDomicilioInterface';

import { ActualizarTipoDomicilio, AgregarTipoDomicilio, TipoDomicilio } from '../../connections/catalogos/TipoDomicilioConnection';

export const TipoDomicilioPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [TipoDomicilioArray, setTipoDomicilioArray] = useState<TipoDomicilioProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idTipoDomicilio, setIdTipoDomicilio] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoDomicilioArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const TipoDomicilioSelected = TipoDomicilioArray.find( ( elem ) => elem.idTipoDomicilio === id );

        if (  TipoDomicilioSelected ) {

            await ActualizarTipoDomicilio({ ...TipoDomicilioSelected, activo: checked }).then( resp => {

                if (  resp.idTipoDomicilio ) {

                    var newArray = TipoDomicilioArray.map( ( elem ) => {

                    if (  elem.idTipoDomicilio === id ) {
                        elem.activo = checked;
                    }

                        return elem;
                    });

                    setTipoDomicilioArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if (  idTipoDomicilio !== 0 ) {

            const TipoDomicilioSelected = TipoDomicilioArray.find( ( elem ) => elem.idTipoDomicilio === idTipoDomicilio );

            if (  TipoDomicilioSelected ) {

                setLoading( true );

                await ActualizarTipoDomicilio({ ...TipoDomicilioSelected, descripcion, }).then( resp => {

                    if (  resp.idTipoDomicilio ) {

                        setTimeout(() => {

                            var newArray = TipoDomicilioArray.map( ( elem ) => {

                                if (  elem.idTipoDomicilio === idTipoDomicilio ) {
                                    elem.descripcion = descripcion;
                                }

                                return elem;
                            });

                            setTipoDomicilioArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const TipoDomicilioAdd: TipoDomicilioProps = {
                idTipoDomicilio: 0,
                descripcion,
                activo: true,
            }

            setLoading( true );

            await AgregarTipoDomicilio( TipoDomicilioAdd ).then( resp => {

                if (  resp.idTipoDomicilio ) {

                    setTimeout(() => {

                        setTipoDomicilioArray([ ...TipoDomicilioArray, resp ]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de domicilio correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setTipoDomicilioArray( [] );

            await TipoDomicilio().then( resp => {

                setTimeout(() => {

                    setTipoDomicilioArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])

    return (

        <Layout breadcrumbs={ [  { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de domicilio' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdTipoDomicilio( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idTipoDomicilio, descripcion, activo } ) => (

                                <TableRow key={ idTipoDomicilio } >

                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idTipoDomicilio }
                                    </TableCell>

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'end' }}>

                                        <Switch
                                            checked={ activo }
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoDomicilio ) }
                                        />

                                        <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdTipoDomicilio( idTipoDomicilio );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                            <EditIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={ 1 } sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}